import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-body-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-caption mt-1"
}
const _hoisted_3 = { class: "text-caption mt-2" }

import { ref, onMounted } from 'vue'
import { api } from '@/composables/api'

// Inventory notification state

export default /*@__PURE__*/_defineComponent({
  __name: 'NotifierCard',
  setup(__props) {

const sendingInventoryNotification = ref(false)
const inventoryNotificationResult = ref<string | null>(null)
const inventoryNotificationError = ref<string | null>(null)
const inventoryStats = ref<any>(null)

// Teacher invitation state
const sendingInvite = ref(false)
const inviteResult = ref<string | null>(null)
const inviteError = ref<string | null>(null)
const inviteFormRef = ref<any>(null)
const inviteForm = ref({
  teacher_name: '',
  teacher_email: ''
})

// Load inventory stats
const loadInventoryStats = async () => {
  try {
    // Get available equipment count
    const equipmentResponse = await api.get('/equipment', { status: 'available' })
    const availableEquipment = equipmentResponse.data || []

    // Count by type
    const byType: Record<string, number> = {}
    availableEquipment.forEach((eq: any) => {
      const type = eq.equipment_type || 'other'
      byType[type] = (byType[type] || 0) + 1
    })

    // Get pending requests to count unique teachers
    const requestsResponse = await api.get('/requests', { status: 'pending' })
    const pendingRequests = requestsResponse.data || []

    // Count unique teacher emails
    const teacherEmails = new Set<string>()
    pendingRequests.forEach((req: any) => {
      if (req.teacher_email) {
        teacherEmails.add(req.teacher_email)
      }
    })

    inventoryStats.value = {
      availableCount: availableEquipment.length,
      byType,
      teacherCount: teacherEmails.size
    }
  } catch (error) {
    console.error('Error loading inventory stats:', error)
  }
}

// Send inventory notification
const sendInventoryNotification = async () => {
  sendingInventoryNotification.value = true
  inventoryNotificationResult.value = null
  inventoryNotificationError.value = null

  try {
    const response = await api.post('/notifications/send-inventory-notification', {})

    if (response.data.success) {
      inventoryNotificationResult.value = response.data.message
    } else {
      inventoryNotificationError.value = response.data.message || 'Failed to send notifications'
    }
  } catch (error: any) {
    console.error('Error sending inventory notification:', error)
    inventoryNotificationError.value = error.response?.data?.detail || 'Failed to send inventory notification. Please try again.'
  } finally {
    sendingInventoryNotification.value = false
  }
}

// Invite teacher
const inviteTeacher = async () => {
  // Validate form
  const { valid } = await inviteFormRef.value.validate()
  if (!valid) return

  sendingInvite.value = true
  inviteResult.value = null
  inviteError.value = null

  try {
    const response = await api.post('/notifications/invite-teacher', {
      teacher_name: inviteForm.value.teacher_name,
      teacher_email: inviteForm.value.teacher_email
    })

    if (response.data.success) {
      inviteResult.value = response.data.message
      // Reset form
      inviteForm.value = {
        teacher_name: '',
        teacher_email: ''
      }
      inviteFormRef.value.resetValidation()
    } else {
      inviteError.value = response.data.message || 'Failed to send invitation'
    }
  } catch (error: any) {
    console.error('Error inviting teacher:', error)
    inviteError.value = error.response?.data?.detail || 'Failed to send invitation. Please try again.'
  } finally {
    sendingInvite.value = false
  }
}

onMounted(() => {
  loadInventoryStats()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, { class: "mb-6" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "large",
              class: "mr-2"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("mdi-bell-ring", -1)
              ]))]),
              _: 1
            }),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Notifier", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_subtitle, null, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode(" Send notifications to teachers and invite new users ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      variant: "outlined",
                      class: "h-100"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "text-h6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              start: "",
                              color: "primary"
                            }, {
                              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                _createTextVNode("mdi-package-variant", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[10] || (_cache[10] = _createTextVNode(" Inventory Notification ", -1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-body-2 mb-3" }, " Send an email notification to all teachers who are assignees of pending requests, informing them about currently available equipment. ", -1)),
                            (inventoryStats.value)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 0,
                                  type: "info",
                                  variant: "tonal",
                                  density: "compact",
                                  class: "mb-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_1, [
                                      _createElementVNode("strong", null, _toDisplayString(inventoryStats.value.availableCount), 1),
                                      _cache[11] || (_cache[11] = _createTextVNode(" device(s) available ", -1))
                                    ]),
                                    (inventoryStats.value.byType && Object.keys(inventoryStats.value.byType).length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inventoryStats.value.byType, (count, type) => {
                                            return (_openBlock(), _createElementBlock("div", { key: type }, _toDisplayString(count) + " " + _toDisplayString(type) + _toDisplayString(count !== 1 ? 's' : ''), 1))
                                          }), 128))
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_3, [
                                      _createElementVNode("strong", null, _toDisplayString(inventoryStats.value.teacherCount), 1),
                                      _cache[12] || (_cache[12] = _createTextVNode(" teacher(s) with pending requests ", -1))
                                    ])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (inventoryNotificationResult.value && !inventoryNotificationError.value)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 1,
                                  type: "success",
                                  variant: "tonal",
                                  density: "compact",
                                  class: "mb-3",
                                  closable: "",
                                  "onClick:close": _cache[0] || (_cache[0] = ($event: any) => (inventoryNotificationResult.value = null))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(inventoryNotificationResult.value), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (inventoryNotificationError.value)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 2,
                                  type: "error",
                                  variant: "tonal",
                                  density: "compact",
                                  class: "mb-3",
                                  closable: "",
                                  "onClick:close": _cache[1] || (_cache[1] = ($event: any) => (inventoryNotificationError.value = null))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(inventoryNotificationError.value), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_actions, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              variant: "elevated",
                              loading: sendingInventoryNotification.value,
                              disabled: !inventoryStats.value || inventoryStats.value.teacherCount === 0,
                              onClick: sendInventoryNotification
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { start: "" }, {
                                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                    _createTextVNode("mdi-email-send", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[15] || (_cache[15] = _createTextVNode(" Send Notification ", -1))
                              ]),
                              _: 1
                            }, 8, ["loading", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      variant: "outlined",
                      class: "h-100"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "text-h6" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              start: "",
                              color: "success"
                            }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode("mdi-account-plus", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[17] || (_cache[17] = _createTextVNode(" Invite Teacher ", -1))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-body-2 mb-3" }, " Send an invitation email to a new teacher, providing them with a link to create an account. ", -1)),
                            _createVNode(_component_v_form, {
                              ref_key: "inviteFormRef",
                              ref: inviteFormRef,
                              onSubmit: _withModifiers(inviteTeacher, ["prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: inviteForm.value.teacher_name,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inviteForm.value.teacher_name) = $event)),
                                  label: "Teacher Name",
                                  variant: "outlined",
                                  density: "compact",
                                  rules: [v => !!v || 'Name is required'],
                                  required: "",
                                  class: "mb-2"
                                }, null, 8, ["modelValue", "rules"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: inviteForm.value.teacher_email,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inviteForm.value.teacher_email) = $event)),
                                  label: "Teacher Email",
                                  type: "email",
                                  variant: "outlined",
                                  density: "compact",
                                  rules: [
                      v => !!v || 'Email is required',
                      v => /.+@.+\..+/.test(v) || 'Email must be valid'
                    ],
                                  required: "",
                                  class: "mb-2"
                                }, null, 8, ["modelValue", "rules"]),
                                (inviteResult.value && !inviteError.value)
                                  ? (_openBlock(), _createBlock(_component_v_alert, {
                                      key: 0,
                                      type: "success",
                                      variant: "tonal",
                                      density: "compact",
                                      class: "mb-3",
                                      closable: "",
                                      "onClick:close": _cache[4] || (_cache[4] = ($event: any) => (inviteResult.value = null))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(inviteResult.value), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (inviteError.value)
                                  ? (_openBlock(), _createBlock(_component_v_alert, {
                                      key: 1,
                                      type: "error",
                                      variant: "tonal",
                                      density: "compact",
                                      class: "mb-3",
                                      closable: "",
                                      "onClick:close": _cache[5] || (_cache[5] = ($event: any) => (inviteError.value = null))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(inviteError.value), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 512)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_actions, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_btn, {
                              color: "success",
                              variant: "elevated",
                              loading: sendingInvite.value,
                              onClick: inviteTeacher
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { start: "" }, {
                                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                                    _createTextVNode("mdi-email-send", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _cache[20] || (_cache[20] = _createTextVNode(" Send Invitation ", -1))
                              ]),
                              _: 1
                            }, 8, ["loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})